import { identifiers } from './multi-select.constants'

export function getStats(
  id: string,
  optionGapInPx: number,
  optionsContainerWidthInPx: number
) {
  return Array.prototype.reduce.call(
    document.querySelectorAll(`[data-id=${id}__${identifiers.option}]`),
    (stats: any, option: HTMLDivElement) => {
      const elementWidth = option.offsetWidth + optionGapInPx
      if (stats.rowWidth + elementWidth > optionsContainerWidthInPx) {
        stats.rowsNumber++
        stats.rowWidth = 0
      }
      stats.rowWidth += elementWidth
      stats.itemsInRow[stats.rowsNumber] =
        (stats.itemsInRow[stats.rowsNumber] || 0) + 1
      return stats
    },
    {
      rowWidth: 0,
      rowsNumber: 0,
      itemsInRow: [], // array indexes represents rows number, values represents how many items in the specific row. [3, 5, 2] says that 1st row contains 3 items, 2nd - 5 and 3rd row has 2 items
    }
  )
}
